var render = function () {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-item-wrapper flex-direction-column",
      class:
        ((_obj = {}),
        (_obj[_vm.getFileStatus(_vm.file)] = true),
        (_obj[
          "file-type-" +
            (_vm.options["list-type"] ? _vm.options["list-type"] : "text")
        ] = true),
        _obj),
      attrs: { title: _vm.getFileName(_vm.file) },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "file-item-content interval flex-direction-row flex-between-center",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "file-item-info interval flex-direction-row flex-auto flex-start-center",
            },
            [
              _vm.options["list-type"] === "picture"
                ? [
                    _c("wl-image", {
                      staticClass: "flex-fixed",
                      style: _vm.imagesSize,
                      attrs: { src: _vm.file.url, fit: _vm.options.fit },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "file-title flex-auto flex-direction-column flex-center-start",
                        style: { "min-width": _vm.imagesSize.width },
                      },
                      [_vm._v(_vm._s(_vm.getFileName(_vm.file)))]
                    ),
                  ]
                : _vm.options["list-type"] === "picture-card"
                ? [
                    _c("wl-image", {
                      staticClass: "flex-fixed",
                      style: _vm.imagesSize,
                      attrs: { src: _vm.file.url, fit: _vm.options.fit },
                    }),
                  ]
                : [
                    _c("div", {
                      staticClass: "file-icon",
                      class: _vm.getIconCalss(_vm.file),
                    }),
                    _c("div", { staticClass: "file-title ellipsis-single" }, [
                      _vm._v(_vm._s(_vm.getFileName(_vm.file))),
                    ]),
                  ],
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass:
                "file-info-wrapper flex-direction-row flex-end-center flex-fixed",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.getFileStatus(_vm.file)
                ? _c(
                    "div",
                    {
                      staticClass: "file-info file-status",
                      class:
                        ((_obj$1 = {}),
                        (_obj$1[_vm.getFileStatus(_vm.file)] = true),
                        _obj$1),
                    },
                    [
                      _vm.getFileStatus(_vm.file) === "ready"
                        ? _c("div", { staticClass: "el-icon-circle-check" })
                        : _vm.getFileStatus(_vm.file) === "success"
                        ? _c("div", { staticClass: "el-icon-success" })
                        : _vm.getFileStatus(_vm.file) === "error"
                        ? _c("div", { staticClass: "el-icon-error" })
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.file.url &&
              _vm.options.full &&
              _vm.options["list-type"] &&
              _vm.options["list-type"].includes("picture")
                ? _c(
                    "div",
                    {
                      staticClass: "file-tool file-tool-download",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.fullImageFile(_vm.file)
                        },
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "el-icon-full-screen",
                        attrs: { title: "放大" },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.file.url
                ? _c(
                    "div",
                    {
                      staticClass: "file-tool file-tool-download",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.downloadFile(_vm.file)
                        },
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "el-icon-download",
                        attrs: { title: "下载" },
                      }),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "file-tool file-tool-delete",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.deleteFile(_vm.file)
                    },
                  },
                },
                [
                  _c("div", {
                    staticClass: "el-icon-delete",
                    attrs: { title: "删除" },
                  }),
                ]
              ),
              _vm.getFileStatus(_vm.file) === "uploading"
                ? _c(
                    "div",
                    { staticClass: "file-info file-upload-percentage" },
                    [
                      _vm._v(
                        _vm._s(parseFloat(_vm.file.percentage).toFixed(2)) + "%"
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm.getFileStatus(_vm.file) === "uploading"
        ? [
            _vm.options["list-type"] === "picture-card"
              ? _c("el-progress", {
                  staticClass: "position-center",
                  class:
                    ((_obj$2 = {}),
                    (_obj$2[
                      _vm.options["list-type"]
                        ? _vm.options["list-type"]
                        : "text"
                    ] = true),
                    _obj$2),
                  attrs: {
                    percentage: _vm.file.percentage,
                    "define-back-color": "#00ff00",
                    type: "circle",
                    width:
                      (_vm.options.width > _vm.options.height
                        ? _vm.options.height
                        : _vm.options.width) * 0.75,
                    "show-text": false,
                    "stroke-width": 10,
                  },
                })
              : _c("el-progress", {
                  staticClass: "position-center",
                  attrs: {
                    percentage: _vm.file.percentage,
                    "show-text": false,
                  },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }